import { render, staticRenderFns } from "./PayBanner.vue?vue&type=template&id=623e6732&scoped=true&"
import script from "./PayBanner.vue?vue&type=script&lang=js&"
export * from "./PayBanner.vue?vue&type=script&lang=js&"
import style0 from "./PayBanner.vue?vue&type=style&index=0&id=623e6732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e6732",
  null
  
)

export default component.exports